import React from "react";
import IntegrationList from "../../components/IntegrationList/IntegrationList";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";
import PlusRoundIcon from "../../assets/icons/PlusRoundIcon";
import styles from "./IntegrationScreen.module.scss";
import ModalAddIntegration from "../../components/ModalAddIntegration/ModalAddIntegration";
import { useModal } from "../../context/ModalContext";

export default function IntegrationScreen() {
  const { modalVisible, openModal, closeModal } = useModal();

  return (
    <ScreenLayout>
      <ScreenHeader
        actions={[
          {
            title: "Создать",
            icon: <PlusRoundIcon />,
            className: styles.addButton,
            titleClassName: styles.titleAddButton,
            onClick: openModal,
          },
        ]}
        title={"Интеграции"}
      />
      {/* {newBot || (activeBot && updateBot) || newTg ? (
        <IntegrationForm data={data ? data() : null} />
      ) : activeBot ? (
        <ActiveBotContainer />
      ) : activeWidget ? (
        <ActiveWidgetContainer />
      ) : activeTg ? (
        <ActiveMessengerContainer messenger={"telegram"} />
      ) : activeWa ? (
        <ActiveMessengerContainer messenger={"whatsapp"} />
      ) : ( */}
      <IntegrationList />
      <ModalAddIntegration onClose={closeModal} visible={modalVisible} />
      {/* )} */}
    </ScreenLayout>
  );
}
